import SecurityEventsPage from "security-app/components/SecurityEvents/Alerts";
import EventReplaySideBarDetails from "security-app/components/SecurityEvents/ReplaySearch/EventReplaySideBarDetails";
import EventDefinitionSideBarDetails from "security-app/components/SecurityEvents/ReplaySearch/EventDefinitionSideBarDetails";
import validLicensePresent from "license/ValidLicensePresent";
const securityEventsBindings = {
  "views.components.securityEventsPage": [
    {
      component: SecurityEventsPage,
      key: "securityEventsTable"
    }
  ],
  "views.components.eventReplay.sideBarDetails": {
    useCondition: validLicensePresent,
    key: "SecurityEventSideBar",
    component: EventReplaySideBarDetails,
    eventDefinitionComponent: EventDefinitionSideBarDetails
  }
};
export default securityEventsBindings;
